import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDayNamesShort, HEADER_ROW_HEIGHT } from '../../utils/boardHelpers';
import type { VisibleWeek } from './timelineHeaderHelpers';

interface TimelineDayRowProps {
  visibleWeeks: VisibleWeek[];
  dayWidth: number;
  isLast: boolean;
}

export const TimelineDayRow = memo(function TimelineDayRow({ visibleWeeks, dayWidth, isLast }: TimelineDayRowProps) {
  const { i18n } = useTranslation();
  const dayNames = useMemo(() => getDayNamesShort(i18n.language), [i18n.language]);
  return (
    <div
      style={{
        position: 'relative',
        height: HEADER_ROW_HEIGHT,
        borderBottom: isLast ? undefined : '1px solid #f1f5f9',
      }}
    >
      {visibleWeeks.map(({ kw, year, startDay }) => (
        <React.Fragment key={`days-${year}-${kw}`}>
          {dayNames.map((name, i) => (
            <div
              key={`${year}-${kw}-${i}`}
              style={{
                position: 'absolute',
                left: (startDay + i) * dayWidth,
                top: 0,
                width: dayWidth,
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                color: '#64748b',
                borderRight: '1px solid #f1f5f9',
              }}
            >
              {dayWidth > 25 ? name : name[0]}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
});
